import React from 'react';
import '../../Pages/Styles/SeccionesDashBoardAdmin.modules.css'

function SeccionesDashBoardAdmin(props) {
    return (
        <div className="dash-board-secciones-component">
            <h1>hola 6</h1>
        </div>
    );
}

export default SeccionesDashBoardAdmin;